/**
 * Flow Optimizer — preview / apply mutation hooks
 * For Media Devoted | Created By Ciro Autiero
 */

import { useMutation } from '@tanstack/react-query';

import {
  applyOptimizer,
  previewOptimizer,
  type FlowOptimizerProvider,
} from '../services/flow-optimizer-api';

export function useFlowOptimizerPreview(
  campaignId: string,
  provider: FlowOptimizerProvider = 'voluum',
) {
  return useMutation({
    mutationFn: () => previewOptimizer(campaignId, provider),
  });
}

export function useFlowOptimizerApply(
  campaignId: string,
  provider: FlowOptimizerProvider = 'voluum',
) {
  return useMutation({
    mutationFn: () => applyOptimizer(campaignId, provider),
  });
}
